export const NAME = 'dashboard';
export const ALL_DASHBOARD_MEASUREMENTS = [
    {value: 'ordersCount', label: 'Orders Count'},
    {value: 'revenue', label: 'Revenue'}
];